export interface TranslationExecution {
  profile: "translation_non_billed_v1" | "entrance_http_v1" | "entrance_http_v2";
  billingMode: "none";
  limits: {
    maxInputBytes: number;
    maxOutputBytes: number;
    maxExecutionSeconds: number;
    requestsPerMinute: number;
    maxConcurrentRequests: number;
  };
}

const maximums: TranslationExecution["limits"] = {
  maxInputBytes: 32768, maxOutputBytes: 1048576, maxExecutionSeconds: 120,
  requestsPerMinute: 60, maxConcurrentRequests: 2
};
const httpMaximums: TranslationExecution["limits"] = {
  maxInputBytes: 1048576, maxOutputBytes: 16777216, maxExecutionSeconds: 120,
  requestsPerMinute: 60, maxConcurrentRequests: 2
};
const httpV2Maximums: TranslationExecution["limits"] = {
  maxInputBytes: 67108864, maxOutputBytes: 67108864, maxExecutionSeconds: 120,
  requestsPerMinute: 60, maxConcurrentRequests: 2
};

export function parseTranslationExecution(value: unknown): TranslationExecution | null {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const item = value as Record<string, unknown>;
  if ((item.profile !== "translation_non_billed_v1" && item.profile !== "entrance_http_v1" && item.profile !== "entrance_http_v2") || item.billingMode !== "none"
      || !item.limits || typeof item.limits !== "object" || Array.isArray(item.limits)) return null;
  if (Object.keys(item).length !== 3 || !Object.keys(item).every((key) => ['profile', 'billingMode', 'limits'].includes(key))) return null;
  const raw = item.limits as Record<string, unknown>;
  const bounds = item.profile === "entrance_http_v2" ? httpV2Maximums : item.profile === "entrance_http_v1" ? httpMaximums : maximums;
  if (Object.keys(raw).length !== 5 || !Object.keys(raw).every((key) => Object.hasOwn(bounds, key))) return null;
  const limits = {} as TranslationExecution["limits"];
  for (const key of Object.keys(maximums) as Array<keyof typeof maximums>) {
    const number = raw[key];
    if (typeof number !== "number" || !Number.isSafeInteger(number) || number <= 0 || number > bounds[key]) return null;
    limits[key] = number;
  }
  return { profile: item.profile, billingMode: "none", limits };
}

export function translationExecutionLimitsText(execution: TranslationExecution, zh: boolean) {
  const l = execution.limits;
  return zh
    ? `输入上限 ${l.maxInputBytes.toLocaleString("en-US")} 字节 · 输出上限 ${l.maxOutputBytes.toLocaleString("en-US")} 字节 · 最长 ${l.maxExecutionSeconds} 秒 · 每分钟 ${l.requestsPerMinute} 次 · 同时 ${l.maxConcurrentRequests} 个请求`
    : `Input up to ${l.maxInputBytes.toLocaleString("en-US")} bytes · Output up to ${l.maxOutputBytes.toLocaleString("en-US")} bytes · Up to ${l.maxExecutionSeconds}s · ${l.requestsPerMinute} requests/min · ${l.maxConcurrentRequests} concurrent requests`;
}
